export default __webpack_public_path__ + "static/media/591.eb94c55d.png";